import React from "react";
import styles from './status.module.scss';

function PaymnetStatus(props) {
  let { data } = props;
  if (data === 1) {
    data = "Not Paid";
  } else if (data === 2) {
    data = "Paid";
  } else if (data === 3) {
    data = "Hold";
  } else if (data === 0) {
    data = "Failed";
  }
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.status} ${styles[data?.replaceAll(" ", '')]}`}>
        <div className={styles.text}>{data}</div>
      </div>
    </div>
  );
}
export default PaymnetStatus;
